export default __webpack_public_path__ + "static/media/grafema_f1rst_01.9c97a9d1.jpg";